import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién empiezo?',
    a: 'Sí. El sistema va de cero a dueña pro. No necesitás experiencia previa en negocios.'
  }, {
    q: '¿Sirve si ya tengo clientas pero no me alcanza el dinero?',
    a: 'Exactamente para eso fue creado. El Tomo 3 y el Bono 1 son los que más impacto inmediato generan.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Inmediatamente después del pago recibís acceso a los 13 archivos del sistema.'
  }, {
    q: '¿Qué lo diferencia de un curso de técnica?',
    a: 'Todo. Esto no enseña a hacer uñas más lindas. Enseña a cobrar lo que merecés, llenar la agenda y escalar los ingresos.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. El 100% del dinero de vuelta si no es lo que esperabas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark-card/30 pt-[25px] pb-[25px]" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-136">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-137">
          {faqs.map((faq, i) => <div key={i} className="bg-dark border border-dark-border rounded-xl overflow-hidden" data-id="element-138">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-139">
                <span className="font-bold text-lg" data-id="element-140">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-141" />
              </button>
              <AnimatePresence data-id="element-142">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-143">
                    <div className="p-6 pt-0 text-gray-400 border-t border-dark-border/50 mt-2" data-id="element-144">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}